var map = {
	"./clock.svg": "4c09",
	"./down.svg": "d681",
	"./geer.svg": "9b3a",
	"./heart.svg": "c40a",
	"./left.svg": "d977",
	"./location.svg": "1c50",
	"./moon.svg": "be6e",
	"./people.svg": "d056",
	"./play.svg": "fb4f",
	"./rank.svg": "2b97",
	"./recordPause.svg": "227f",
	"./recordPlay.svg": "b4c4",
	"./recordRefresh.svg": "89d9",
	"./recordStart.svg": "202b",
	"./recordStop.svg": "66c9",
	"./recordUpload.svg": "f3de",
	"./refresh.svg": "b8c4",
	"./sun.svg": "a776",
	"./up.svg": "1380",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";